import { useState, useEffect } from "react";
import { pdfjs } from "react-pdf";
import { useStore } from "../../context";

export const usePdf = () => {
  const file = useStore(({ file: f }) => f.getFile());

  /* Local State */
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageText, setPageText] = useState<string>("");
  const [pdfDocument, setPdfDocument] = useState<pdfjs.PDFDocumentProxy | null>(null);

  /**
   * Handlers
   **/
  const onDocumentLoadSuccess = (pdf: pdfjs.PDFDocumentProxy) => {
    setNumPages(pdf.numPages);
    setPageNumber(1);
    setPdfDocument(pdf);
  };

  // Extract text when page number changes
  useEffect(() => {
    const extractText = async () => {
      if (!pdfDocument) {
        return;
      }

      try {
        const page = await pdfDocument.getPage(pageNumber);
        const textContent = await page.getTextContent();
        const text = textContent.items
          .map((item: any) => item.str)
          .join(" ")
          .trim();
        setPageText(text);
      } catch (error) {
        setPageText("");
      }
    };

    extractText();
  }, [pageNumber, pdfDocument]);

  const changePage = (offset: number) => {
    const newPageNumber = pageNumber + offset;
    setPageNumber(newPageNumber);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  return {
    numPages,
    pageNumber,
    onDocumentLoadSuccess,
    previousPage,
    nextPage,
    pageText,
  };
};
